<template>
	<div :class="{
		'resource-view': true,
		'compact': condensed
	}">
		<div class="header">
			<div class="list">
				<div style="visibility: hidden;" class="pin" @click="togglePinned()">
					<svg-icon :class="{
						icon: true,
						active: pinned
					}" icon="pin" />
				</div>
				<div class="title">
					Opgaver
					<div v-if="selected.length > 0" style="position: absolute; display: grid; grid-template-columns: auto auto; top: 0; right: 0;">
						<div style="cursor: pointer; margin-right: 20px; color: rgb(0, 189, 0);" @click="approveAll()">Godkendt</div>
						<div style="cursor: pointer; margin-right: 20px; color: #999;" @click="selected = []">Ryd</div>
					</div>
				</div>
			</div>
			<div class="plan">
				<svg>
					<line v-for="i in 23" v-bind:key="i" :x1="((i / 24) * 100) + '%'" y1="100%" :x2="((i / 24) * 100) + '%'" y2="50px"></line>
				</svg>
				<div class="number" :style="{ left: (((i / 24) * 100) - ((0.5 / 24) * 100)) + '%' }" v-for="i in 23" v-bind:key="i">{{ i }}</div>
			</div>
		</div>
		<div class="body">
			<div class="bg">
				<div class="list"></div>
				<div class="plan">
					<svg>
						<line :class="i % 2 == 1 ? 'odd' : ''" v-for="i in 47" v-bind:key="i" :x1="((i / 48) * 100) + '%'" y1="0%" :x2="((i / 48) * 100) + '%'" y2="100%"></line>
						<line v-if="time" class="time" :x1="(((time.seconds + 1) / 86400) * 100) + '%'" y1="0%" :x2="(((time.seconds + 1) / 86400) * 100) + '%'" y2="100%"></line>
					</svg>
				</div>
			</div>
			<perfect-scrollbar class="content" style="padding: 20px 0 20px 0;">
				<transition-group appear class="role" tag="div" name="item">
					<div v-if="false" class="title" :key="'title' + i">
						<div class="list">
							<div class="arrow" style="display: none;">X</div>
							<div class="title">{{ group.label }}</div>
						</div>
						<div class="plan">
							
						</div>
					</div>


					<div :class="{
						item: true,
						title2: item.type == 'title'
					}" v-for="(item, j) in _rows" :key="j">
						<!-- TASK -->		
						<div v-if="item.type == 'title'" class="list">
							<div class="pos">
								<svg-icon icon="gallery" :class="{
									gallery: true,
									active: item.data.hasOwnProperty('details') && item.data.details.hasOwnProperty('photos') && item.data.details.photos.length > 0
								}" @click="$store.commit('gallery', item.hasOwnProperty('data') && item.data.hasOwnProperty('details') && item.data.details.hasOwnProperty('photos') ? item.data.details.photos : [])" />
							</div>
							<div class="name title2" @mouseenter="$store.commit('hover', [item.data, 'right', 'task'])" @mouseleave="$store.commit('hover', [null, 'right', null])" @click="open(item.data.order_id)" @contextmenu.prevent="context(item.data)" style="cursor: pointer;">{{ item.label }}</div>
							<div v-if="item.data.closed !== null" class="time closed">{{ item.data.closed | timestamp }}</div>
							<div v-if="item.data.closed === null" class="time open">IKKE LUKKET</div>
						</div>
						<div v-if="item.type == 'title'" class="plan">
							
						</div>				

						<!-- EMPLOYEE -->
						<div v-if="item.type == 'employee'" class="list" @mouseenter="enterEmployee(item)" @mouseleave="leaveEmployee(item)">
							<div class="pos">
								<svg-icon :class="{
									up: true,
									disabled: true
								}" icon="arrow_up" @click="move(res, -1)" />
								<svg-icon :class="{
									pin: true,
									active: item.data.warnings.length + item.data.comments.length > 0
								}" icon="warning" @click="$emit('', res)" />
								<svg-icon :class="{
									down: true,
									disabled: true
								}" icon="arrow_down" @click="move(res, 1)" />
							</div>
							<check-view v-show="selected.filter((itm) => { return itm.id == item.data.id; }).length > 0 || hover == item.data.id" style="position: absolute; left: 20px; top: 2px;" @input="checkEmployee" :value="selected.filter((itm) => { return itm.id == item.data.id; }).length > 0" :data="{ id: item.data.id, hours: $options.filters.roundHours(item.data.hours) }" />
							<div class="name">{{ item.data.name }}</div>
							<div class="time back">{{ getTime(item.data) }}</div>
							<div @click="$emit('approve', item.data)" v-if="item.data.approved === null" :class="{
								time: true,
								lvl1: true,
								flag: item.flag
							}">{{ item.data.hours | roundHours | formatHours }}</div>
							<div @contextmenu.prevent="$emit('context', item.data)" @click="$emit('approve', item.data)" v-if="item.data.approved !== null && item.data.transferred === null" class="time lvl2">{{ item.data.approved | formatHours }}</div>
							<div @contextmenu.prevent="$emit('context', item.data)" @click="$emit('approve', item.data)" v-if="item.data.approved !== null && item.data.transferred !== null" class="time lvl3">{{ item.data.approved | formatHours }}</div>
						</div>
						<div v-if="item.type == 'employee'" class="plan" style="position: relative;">
							<div class="blocks" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%;">
								<div v-for="(block, bl) in item.data.blocks" :key="bl" :style="{
									position: 'absolute',
									height: '100%',
									backgroundColor: block.color,
									left: (getTimeCoeff(block.from) * 100) + '%',
									width: ((getTimeCoeff(block.to) - getTimeCoeff(block.from)) * 100) + '%',
									opacity: 0.15
								}"></div>
							</div>
							<transition-group name="track" tag="div">
								<div class="track" v-for="(track, i) in _tracks[item.data.id]" :key="i" :style="{
									position: 'relative',
									height: '16px'
								}">
									<div :class="{
										task: true,
										red: mode == 'accounting' ? (item.full.order_id !== null && item.full.order_status != 'invoiced' && item.full.order_status != 'closed') : (item.full.hours.status == 'open'),
										yellow: mode == 'accounting' ? (item.full.order_id !== null &&  item.full.order_status == 'invoiced') : false,
										green:  mode == 'accounting' ? (item.full.order_id === null || item.full.order_status == 'closed') : (item.full.hours.status == 'closed')
									}" v-for="(item, k) in track" :key="k" :style="{
										backgroundColor: item.color,
										position: 'absolute',
										left: (getTimeCoeff(item.from) * 100) + '%',
										width: ((getTimeCoeff(item.to) - getTimeCoeff(item.from)) * 100) + '%',
										cursor: 'pointer'
									}" :title="item.span" @mouseenter="$store.commit('hover', [item.full, 'left', 'task'])" @mouseleave="$store.commit('hover', [null, 'left', null])" @click="open(item.full)" @contextmenu.prevent="context($event, item.full)">
										#{{ item.num }} {{ item.label }}
										<div class="color"></div>
										<div class="body">
											<div class="title">TITLE</div>
											<div class="zip">EXTRA</div>
										</div>
									</div>								
								</div>
							</transition-group>
						</div>

						<!-- VEHICLES -->
						<div v-if="item.type == 'vehicle'" class="list" @mouseenter="$store.commit('hover', [item.data, 'right', 'vehicle'])" @mouseleave="$store.commit('hover', [null, 'right', null])">
							<div class="pos">
								<svg-icon icon="history" :class="{
									gallery: true,
									active: true
								}" @click="gps(item.data.id)" />
							</div>
							<div class="name">{{ item.data.name }}</div>
							<div class="time back">{{ getVehicleTime(item) }}</div>
							<div class="time">{{ getVehicleHours(item) }}</div>
						</div>
						<div v-if="item.type == 'vehicle'" class="plan" style="position: relative;">
							<div class="blocks" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%;">
								<div v-for="(block, bl) in item.data.blocks" :key="bl" :style="{
									position: 'absolute',
									height: '100%',
									backgroundColor: block.color,
									left: (getTimeCoeff(block.from) * 100) + '%',
									width: ((getTimeCoeff(block.to) - getTimeCoeff(block.from)) * 100) + '%',
									opacity: 0.1
								}"></div>
							</div>
							<transition-group name="track" tag="div">
								<div class="track" v-for="(track, i) in _vehicleTracks[item.data.id]" :key="i" :style="{
									position: 'relative',
									height: '16px'
								}">
									<div class="task vehicle" v-for="(item, k) in track" :key="k" :style="{
										backgroundColor: item.color,
										position: 'absolute',
										left: (getTimeCoeff(item.from) * 100) + '%',
										width: ((getTimeCoeff(item.to) - getTimeCoeff(item.from)) * 100) + '%',
									}" :title="item.label">
										{{ item.label }}
										<div class="color"></div>
										<div class="body">
											<div class="title">TITLE</div>
											<div class="zip">EXTRA</div>
										</div>
									</div>								
								</div>
							</transition-group>
						</div>
					</div>



				</transition-group>
			</perfect-scrollbar>
			<legend-view :items="taskTypes" />
		</div>
	</div>
</template>

<script>
	import DragTargetMixin from '../../mixins/DragTargetMixin'
	import CompareDatesMixin from '../../mixins/CompareDatesMixin'
	import WeekNumberMixin from '../../mixins/WeekNumberMixin'
	import LegendView from './LegendView'
	import QuoteModel from '../model/Order'
	import QuoteWindow from '../windows/OrderWindow'
	import TaskModel from '../model/Task'
	import TaskWindow from '../windows/TaskWindow'
	import QQuoteModel from '../model/Quote'
	import QQuoteWindow from '../windows/QuoteWindow'
	import { bus } from '../../bus'

	import ContextPopupView from './ContextPopupView'

	import HoursCorrectionWindow from '../windows/HoursCorrectionWindow'

	export default {
		mixins: [
			DragTargetMixin,
			CompareDatesMixin,
			WeekNumberMixin
		],
		components: {
			LegendView
		},
		data: function () {
			return {
				selected: [],
				hover: null,
				type: null,
				timer: null,
				time: null,
				tab: null,
				taskTypes: [],
				sorting: {
					value: 'personal',
					options: {
						personal: 'Personlig',
						alpha: 'Alfabetisk'
					}
				},
				pinned: false
				//hoverRes: null
			};
		},
		props: {
			mode: {
				type: String,
				default: 'accounting'
			},

			search: {
				type: String,
				default: ''
			},

			filter: {
				type: String,
				default: 'all'
			},
			sort: {
				type: String,
				default: 'task'
			},
			employees: {
				type: Array,
				default() {
					return [];
				}
			},
			vehicles: {
				type: Array,
				default() {
					return [];
				}
			},

			events: {
				type: Array,
				default() {
					return [];
				}
			},



		
			filters: {
				type: Array,
				default() {
					return [];
				}
			},
			condensed: {
				type: Boolean,
				default: true
			},
			planned: {
				type: Boolean,
				default: true
			},
			free: {
				type: Boolean,
				default: true
			},
			internal: {
				type: Boolean,
				default: true
			},
			external: {
				type: Boolean,
				default: true
			},
			info: {
				type: String,
				default: 'zip'
			},
			drag: {
				type: Object,
				default() {
					return null;
				}
			},
			/*hover: {
				type: Object,
				default() {
					return null;
				}
			},*/
			hoverRes: {
				type: Object,
				default() {
					return null;
				}
			},
			resources: {
				type: Array,
				default: function () {
					return [];
				}
			},
			types: {
				type: Object,
				default: function () {
					return {};
				}
			},
			reservations: {
				type: Array,
				default: function () {
					return [];
				}
			},
			tasks: {
				type: Array,
				default: function () {
					return [];
				}
			},
			bookings: {
				type: Array,
				default: function () {
					return [];
				}
			},
			date: String
		},
		watch: {
			date() {
				if (this.compareDates(Date.normDate(this.date), new Date()) == 0) {
					this.startTimer();
				} else {
					this.stopTimer();
				}
			},
			drag(n, o) {
				if (n === null) {
					this.hover = null;
				}
			},
			_groups() {
				//

				if (!this.tab && this._groups.length > 0) {
					this.tab = this._groups[0].label;
				} else if (this._groups.length == 0) {
					this.tab = null;
				}
			},
			_rows(n) {
				

				// Print all tasks
			},
			tasks(n) {
				
			}
		},
		computed: {
			_employees() {
				var r = [];

				const tasks = this.tasks;
				const bookings = this.bookings;	

				for (var i = 0; i < this.employees.length; ++i) {
					var emp = this.employees[i];

					/*emp.tasks = bookings.filter((item) => {
						return item.res_id == emp.id && item.res_type == 'employee';
					}).reduce((acc, book) => {
						return acc.concat(tasks.filter((task) => {
							return task.id == book.task_id;
						}));
					}, []);*/

					//

					if (this.filter == 'all') {
						r.push(emp);
					} else if (this.filter == 'pending' && this.employees[i].approved === null) {
						r.push(emp);
					} else if (this.filter == 'approved' && this.employees[i].approved !== null) {
						r.push(emp);
					}
				}

				return r;
			},



			_rows() {
				var r = [];
				var used = [];

				for (var i = 0; i < this.tasks.length; ++i) {
					var t 		= this.tasks[i];
					var books 	= this.bookings.filter((item) => {
						return item.task_id == t.id;
					});

					// Get employees
					var taskEmps = [];

					for (var j = 0; j < this._employees.length; ++j) {
						var e = this._employees[j];

						for (var k = 0; k < books.length; ++k) {
							if (books[k].res_type == 'employee' && books[k].res_id == e.id) {
								

								taskEmps.push({
									type: 'employee',
									label: e.name,
									data: {...e, tracks: this._tracks[e.id], control: true },
									task: this._tasks[books[k].task_id],
									flag: t.order_cost > t.order_total
								});

								used.push(e.id);

								break;
							}
						}
					}

					// Add task, employees and vehicles
					if (taskEmps.length > 0) {
						

						// Add employees
						//r = r.concat(taskEmps);

						// Add vehicles
						var vehs = [];

						for (var j = 0; j < this.vehicles.length; ++j) {
							var v = this.vehicles[j];

							for (var k = 0; k < books.length; ++k) {
								if (books[k].res_type == 'vehicle' && books[k].res_id == v.id) {
									// Add start stop blocks from events
									const events = this.events.filter((item) => {
										return item.vehicle_id == v.id;
									});

									v.blocks = events.filter((item) => {
										return item.event == 'start' || item.event == 'stop';
									}).reduce((acc, item) => {
										const colors = {
											start: 	'green',
											stop:	'red'
										};
	
										if (acc.last !== null) {
											acc.acc.push({
												color: 	colors[acc.last.event],
												type:	acc.last.event,
												from:	acc.last.logged,
												to:		item.logged,
												label:	acc.last.address	
											});
										}

										acc.last = item;

										return acc;
									}, {
										last: null,
										acc: []
									}).acc;

									// First
									const leave = events.filter((item) => {
										return item.event == 'leave';
									});		
									
									// Last
									const enter = events.filter((item) => {
										return item.event == 'enter';
									});	

									enter.reverse();

									vehs.push({
										type: 'vehicle',
										label: v.name,
										data: v,
										leave: leave.length > 0 ? leave[0] : null,
										enter: enter.length > 0 ? enter[0] : null
									});

									break;
								}
							}
						}

						//

						// Sort vehicles
						vehs.sort(function (a, b) {
							if (a.data.name < b.data.name) return -1;
							if (a.data.name > b.data.name) return 1;
							return 0;
						});

						

						if (this.search == '' || vehs.reduce((acc, item) => { return acc || (item.label.toLowerCase().indexOf(this.search) > -1); }, false) || taskEmps.reduce((acc, item) => { return acc || (item.label.toLowerCase().indexOf(this.search) > -1); }, false) || `#${t.num} ${t.name}`.toLowerCase().indexOf(this.search) > -1) {
							r.push({
								type: 'title',
								label: 	`#${t.num} ${t.name}`,
								data: t,
								employees: taskEmps,
								vehicles: vehs
							});
						}
					}					
				}

				

				// Regroup??
				// -

				// Sort
				const self = this;

				r.sort(function (a, b) {
					if (self.sort == 'task') {
						if (a.data.num < b.data.num) return -1;
						if (a.data.num > b.data.num) return 1;
						return 0;
					}

					if (self.sort == 'vehicle') {
						const sort = function (a, b) {
							if (a.length == 0 && b.length > 0) return -1;
							if (a.length > 0 && b.length == 0) return 1;
							if (a.length == 0 && b.length == 0) return 0;
							if (a[0].data.name < b[0].data.name) return -1;
							if (a[0].data.name > b[0].data.name) return 1;
							if (a[0].data.name == b[0].data.name) return 0;

							a.shift();
							b.shift();
							return sort(a, b);
						};

						return sort(a.vehicles, b.vehicles);
					}

					if (self.sort == 'name') {
						if (a.data.name < b.data.name) return -1;
						if (a.data.name > b.data.name) return 1;
						return 0;
					}
				});

				// Flatten
				const from = Array.from(r);
				r = [];

				for (i = 0; i < from.length; ++i) {
					// Add task
					r.push(from[i]);

					// Add employees
					r = r.concat(from[i].employees);

					// Add vehicles
					r = r.concat(from[i].vehicles);
				}

				// No task hours
				var emps = this._employees.filter((item) => {
					return item.hours > 0 && !used.includes(item.id);
				});

				if (emps.length > 0) {
					r.push({
						type: 'title',
						label: 'Uden opgaver',
						data: {}
					});

					for (var i = 0; i < emps.length; ++i) {
						var e = emps[i];

						r.push({
							type: 'employee',
							label: e.name,
							data: e,
							task: null
						});
					}
				}

				return r;
			},

			_tracks() {
				var r = {};

				for (var i = 0; i < this.employees.length; ++i) {
					var e = this.employees[i];
					r[e.id] = [];

					for (var j = 0; j < e.tasks.length; ++j) {
						// Glemt stempel ind/ud fjernes her
						if (!this._tasks.hasOwnProperty(e.tasks[j].id)) {
							continue;
						}

						e.tasks[j].full = this._tasks[e.tasks[j].id];
						r[e.id].push([e.tasks[j]]);
					}
				}

				

				return r;
			},

			_vehicleTracks() {
				var r = {};
				var self = this;

				for (var i = 0; i < this.vehicles.length; ++i) {
					var stops = [];
					var v = this.vehicles[i];
					r[v.id] = [];

					var fences = [];
					var open = null;

					for (var j = 0; j < this.events.length; ++j) {
						var e = this.events[j];

						if (e.vehicle_id != v.id) continue; 

						if (open === null && e.event == 'enter') {
							
							open = e;
						} else if (open === null && e.event == 'leave') {
							

							stops.push({
								color:	'#ffffffaa',
								from:	`${this.date} 00:00`,
								to:		e.logged,
								label:	e.address
							});
						} else if (open !== null && e.event == 'leave' && e.address == open.address) {
							fences.push({
								enter: open,
								leave: e
							});

							open = null;
						}
					}

					for (var j = 0; j < fences.length; ++j) {
						var f = fences[j];

						stops.push({
							color:	'#ffffffaa',
							from:	f.enter.logged,
							to:		f.leave.logged,
							label:	f.enter.address
						});
					}

					if (open !== null) {
						

						stops.push({
							color:	'#ffffffaa',
							to:		`${this.date} 24:00`,
							from:	open.logged,
							label:	open.address
						});
					}

					r[v.id] = [stops];
				}

				


				

				return r;
			},

			_filters() {
				if (!Array.isArray(this.filters)) return {}; 

				var r = {};

				for (var i = 0; i < this.filters.length; ++i) {
					if (this.filters[i] === null) continue;
					r[this.filters[i].value] = this.filters[i];
				}

				return r;
			},
			_tabs() {
				return this._groups.map(function (group) {
					return {
						label: group.label,
						value: group.label,
						badge: null
					};
				});
			},

			indexedTypes() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				return r;
			},
			sortedResources() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = {};

					for (var j = 0; j < this.types[i].roles.length; ++j) {
						r[this.types[i].name][this.types[i].roles[j].name] = [];
					}
				}

				for (var i = 0; i < this.resources.length; ++i) {
					for (var j = 0; j < this.resources[i].roles.length; ++j) {
						

						
							r[this.resources[i].type][this.resources[i].roles[j]].push(this.resources[i]);
						
					}
				}

				return r;
			},
			_reservations() {
				var r = {};

				// Pre populate
				for (var i = 0; i < this.resources.length; ++i) {
					r[this.resources[i].type + this.resources[i].id] = [];
				}

				//

				for (var i = 0; i < this.reservations.length; ++i) {
					var reserve = this.reservations[i];

					//if (reserve.status == 'denied') continue;

					// Add employees
					if (r.hasOwnProperty(reserve.type + reserve.id)) {
						r[reserve.type + reserve.id].push(reserve);
					}
				}

				

				return r;
			},
			_tasks() {
				var r = {};

				for (var i = 0; i < this.tasks.length; ++i) {
					r[this.tasks[i].id] = this.tasks[i];
				}

				return r;
			},
			_resources() {
				var self = this;

				var rs = Array.isArray(this.resources) ? this.resources.map(function (res) {
					res.visible = res.filters.indexOf(self.filter) > -1 && !(self.pinned && !res.pinned); //res.group == self.tab;
					res.tracks = self.getTracks(res);

					return res;
				}) : [];

				// SORT HERE
				if (this.sorting.value == 'personal') {
					
					rs.sort(function (a, b) { return a.order >= b.order ? 1 : -1; });
				}

				if (this.sorting.value == 'alpha') {
					
					rs.sort(function (a, b) { return a.name >= b.name ? 1 : -1; });
				}

				return rs;
			},
			_groups() {
				var r = [];

				for (var i = 0; i < this._resources.length; ++i) {
					/*if (this.pinned && !this._resources[i].pinned) {
						continue;
					}*/

					var match = false;

					for (var j = 0; j < r.length; ++j) {
						if (r[j].label == this._resources[i].group) {
							r[j].res.push(this._resources[i]);
							match = true;
							break;
						}
					}

					if (!match) {
						r.push({
							label: this._resources[i].group,
							res: [this._resources[i]]
						});
					}
				}

				return r;
			},
			_date() {
				
				return new Date(this.date + ' 00:00');
			},
			_bookings() {
				var r = {};
				var id;

				//

				for (var i = 0; i < this.bookings.length; ++i) {
					id = this.bookings[i].res_type + '_' + this.bookings[i].res_id;

					//

					if (r.hasOwnProperty(id)) {
						//
						r[id].push(this.bookings[i]);
					} else {
						r[id] = [this.bookings[i]];
					}
				}

				//

				return r;
			}
		},
		methods: {
			async approveAll() {
				

				var jobs = [];

				for (var i = 0; i < this.selected.length; ++i) {
					var sel = this.selected[i];

					

					jobs.push(this.axios.put(`/employees/${sel.id}/hours/${this.date}`, {
						extra: '',
						hours: sel.hours * 60,
						remarks: ''
					}));
				}

				this.selected = [];
				await Promise.all(jobs);
				this.$emit('update');
			},
			enterEmployee(item) {
				this.$emit('enterEmployee', item.data);
				this.hover = item.data.id;
			},
			leaveEmployee(item) {
				this.$emit('leaveEmployee', item.data);
				this.hover = null;
			},
			checkEmployee(state, data) {
				
				

				for (var i = 0; i < this.selected.length; ++i) {
					if (this.selected[i].id == data.id) {
						this.selected.splice(i, 1);
						return;
					}
				}

				this.selected.push(data);

				
			},
			gps(vehicle_id) {
				this.$store.commit('gps', {
					vehicle_id: vehicle_id,
					from: `${this.date} 00:00`,
					to: `${this.date} 24:00`
				});
			},
			async open(full) {
				if (this.mode == 'accounting') {
					const id = full.order_id;

					if (!id) {
						alert('Denne opgave har ingen ordre');
						return;
					}

					

					var self = this;
					var order = {};
					
					var ent = id ? await QuoteModel.read(self.axios, id) : QuoteModel.entity();

					if (!id) {
						ent.employee_id 		= self.$store.state.employee.id;
						ent.department_id 		= self.$store.state.employee.department_id;
						ent._embedded.employee	= self.$store.state.employee;
					}

					this.$store.state.windowStack.push(QuoteWindow, {
						value: ent, 
						submit: async function (entity, invoice = false, paid = false) {
							if ((order = await QuoteModel.save(self.axios, entity, invoice, paid))) {
								//self.$store.state.windowStack.pop();
								//bus.$emit('update');
							}
						}
					});
				} else if (this.mode == 'hours') {
					

					var self = this;

					var ent = full.id ? await TaskModel.read(self.axios, full.id) : TaskModel.entity();

					this.$store.state.windowStack.push(HoursCorrectionWindow, {
						entity: ent, 
						submit: async function (hours) {
							

							await self.axios.put(`/tasks/${full.id}/hours/`, hours);
							this.$store.state.windowStack.pop();
							bus.$emit('update');
						}
					});
				}
			},
			getTimeCoeff(date) {
				var ms = (new Date(date)).getTime() - this._date.getTime();
				return ms / (1000.0 * 60 * 60 * 24);
			},

			getTimePercent(date) {
				var ms = this._date.getTime() - (new Date(date)).getTime();
				return 100.0 * ms / (1000.0 * 60 * 60 * 24);
			},

			move(res, rel) {
				if (this.sorting.value != 'personal' || this.condensed) return;
				

				// Find over and under
				var idOver = null;
				var idUnder = null;

				var bOver = null;
				var passed = false;

				for (var i = 0; i < this._resources.length; ++i) {
					var r = this._resources[i];

					if (idOver === null && r.visible && r.id != res.id) {
						bOver = r.id;
					}

					if (r.visible && passed) {
						idUnder = r.id;
						passed = false;
					}

					if (r.id == res.id) {
						passed = true;

						if (bOver !== null) {
							idOver = bOver;
						}
					}

					
				}

				

				var ids = [];

				if (rel == -1 && idOver !== null) {
					

					for (var i = 0; i < this._resources.length; ++i) {
						var r = this._resources[i];
						
						if (!r.visible) continue;
						if (r.id == res.id) continue;
						if (r.id == idOver) ids.push(res);
						ids.push(r);
					}
				} else if (rel == 1 && idUnder !== null) {
					

					for (var i = 0; i < this._resources.length; ++i) {
						var r = this._resources[i];

						if (!r.visible) continue;
						if (r.id == res.id) continue;
						ids.push(r);
						if (r.id == idUnder) ids.push(res);
					}
				} else {
					for (var i = 0; i < this._resources.length; ++i) {
						var r = this._resources[i];

						if (!r.visible) continue;
						ids.push(r);
					}
				}

				this.$emit('move', ids);
			},
			getTime(res) {
				

				if (typeof res == 'undefined' || typeof res.tracks == 'undefined') {
					return '-';
				}

				return res.tracks.length > 0 && res.tracks[0][0].full.meeting_time ? res.tracks[0][0].full.meeting_time.substr(0, 5) : '-';
			},
			getVehicleTime(res) {
				
				if (res.enter === null || res.leave === null) return '-';
				
				const enter = new Date(res.enter.logged);
				const leave = new Date(res.leave.logged);

				if (leave > enter) return '-';



				return `${leave.format('H:i')} - ${enter.format('H:i')}`;
				/*

				if (typeof res == 'undefined' || typeof res.tracks == 'undefined') {
					return '-';
				}

				return res.tracks.length > 0 && res.tracks[0][0].full.meeting_time ? res.tracks[0][0].full.meeting_time.substr(0, 5) : '-';*/
			},
			getVehicleHours(res) {
				
				if (res.enter === null || res.leave === null) return '-';
				
				const enter = new Date(res.enter.logged);
				const leave = new Date(res.leave.logged);

				if (leave > enter) return '-';

				

				return this.$options.filters.formatHours((enter.getTime() - leave.getTime()) / 3600 / 1000);

				/*

				if (typeof res == 'undefined' || typeof res.tracks == 'undefined') {
					return '-';
				}

				return res.tracks.length > 0 && res.tracks[0][0].full.meeting_time ? res.tracks[0][0].full.meeting_time.substr(0, 5) : '-';*/
			},
			/*context(booking, res, task) {
				var self = this;

				return function (event) {
					
					self.$emit('context', event.target, booking, res, task);
				}
			},*/
			context(event, item) {
				

				var self = this;

				var actions = [];

				/*actions.push({
					label: 'Åben opgave',
					async action() {
						var ent = await TaskModel.read(self.axios, item.id);

						self.$store.state.windowStack.push(TaskWindow, {
							value: ent, 
							submit: async function (entity) {
								if (await TaskModel.save(self.axios, entity)) {
									self.$store.state.windowStack.pop();
									bus.$emit('update');
								}
							}
						});
					}
				});*/

				if (item.order_quote_id) {
					actions.push({
						label: 'Åben tilbud',
						async action() {
							var ent = await QQuoteModel.read(self.axios, item.id);

							self.$store.state.windowStack.push(QQuoteWindow, {
								value: ent, 
								submit: async function (entity) {
									if (await QQuoteModel.save(self.axios, entity)) {
										self.$store.state.windowStack.pop();
										bus.$emit('update');
									}
								}
							});
						}
					});
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions: actions
				});
			
	



				/*
				var self = this;
				var order = {};
				
				var ent = id ? await QuoteModel.read(self.axios, id) : QuoteModel.entity();

				if (!id) {
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
				}

				this.$store.state.windowStack.push(QuoteWindow, {
					value: ent, 
					submit: async function (entity, invoice = false, paid = false) {
						
							ent: 		entity,
							invoice: 	invoice,
							paid: 		paid
						});

						if ((order = await QuoteModel.save(self.axios, entity, invoice, paid))) {
							//self.$store.state.windowStack.pop();
							//self.update();
						}
					}
				});
				*/
			},
			async setTime(res) {
				

				if (res.tracks.length == 0 || res.tracks[0].length == 0) {
					alert('Der er ingen opgaver at give en mødetid');
					return;
				}

				var taskId = res.tracks[0][0].task.id;

				var time = prompt('Tidspunkt?', (new Date(res.tracks[0][0].task.from.time)).format('H:i'));
				if (time === null) return;

				await this.axios.put('/tasks/' + taskId + '/meeting-time/', { time: time });
				bus.$emit('update');
			},
			zipCodes(s) {
				if (s.from.zip == s.to.zip || s.to.zip == '') {
					return s.from.zip;
				} else {
					return s.from.zip + ' til ' + s.to.zip;
				}
			},
			getInfo(task) {
				if (this.info == 'zip') {
					return this.zipCodes(task.route[0]);
				}

				if (this.info == 'arrival') {
					return this.$options.filters.timestamp(task.from.time);
				}

				if (this.info == 'volume') {
					return task.secondary;
				}

				if (this.info == 'summary') {
					return task.summary;
				}
			},
			getStatusStyle(res) {
				if (res.type == 'employee') {
					//
					var colors = {
						out:	'#f7223f',
						in: 	'#00c017',
						resume:	'#00c017',
						pause: 	'#ffcf00'
					};
					var bg = colors[res.status];

					return {
						position: 'absolute',
						width: '12px',
						height: '12px',
						left: this.condensed ? '50px' : '85px',
						top: this.condensed ? '4px' : '10px',
						border: '3px solid white',
						borderRadius: '50%',
						backgroundColor: bg
					};
				} else {
					return {
						display: 'none'
					};
				}
			},
			itemStyle(res) {
				var tracks = this.getTracks(res);
				var height;
				var opacity = 1;
				var pointerEvents = 'auto';
				var marginBottom = 10;

				if (this.condensed) {
					height = tracks.length > 1 ? (tracks.length * 16) + 2 : 18;			
				} else {
					height = tracks.length > 1 ? (tracks.length * 63) + 5 : 63 + 5;	
				}

				if (!res.visible) {
					height = 0;
					opacity = 0;
					pointerEvents = 'none';
					marginBottom = 0;
				}

				return {
					height: height + 'px',
					opacity: opacity,
					pointerEvents: pointerEvents,
					marginBottom: marginBottom + 'px'
				};
			},
			planColor(res) {
				var color = '#a7a7a7';
				//var cl = '#00000000';

				if (this._reservations[res.type + res.id].length > 0) {
					var r = this._reservations[res.type + res.id][0];

					//

					//background-color: #00c01623;
							/*background-color: #f5ed0333;
							background-color: #f7223e27;*/

					color = r.color;

					/*if (r.booking) {
						color = 'blue';
					}*/

					/*if (r.blocking) {
						color = '#f7223e27';
					}

					//

					if (r.status == 'requested') {
						color = '#f5ed0333';
					}*/
				}

				return color;
			},
			planStyle(res) {
				/*var tracks = this.getTracks(res);

				if (this.condensed) {
					var height = tracks.length > 1 ? (tracks.length * 16) + 2 : 18;			
				} else {
					var height = tracks.length > 1 ? (tracks.length * 63) + 5 : 63 + 5;	
				}*/

				var color = this.planColor(res) + '11';
				var cl = '#00000000';

				//

				

				return {
					backgroundColor: color,
					color: 'black'
				};
			},
			planDesc(res) {
				var s = {
					label: '',
					note: ''
				};

				//

				if (this._reservations[res.type + res.id].length > 0) {
					var r = this._reservations[res.type + res.id][0];

					//

					//background-color: #00c01623;
							/*background-color: #f5ed0333;
							background-color: #f7223e27;*/

					s.label = r.label;
					s.note = r.note;
				}

				return s;
			},
			taskStyle(item) {
				//var stop = item.task.route[item.stopIdx];
				var day = 24 * 60;

				//

				var left = 0;
				var from = Date.normDate(item.booking.from);

				if (from.format('Y-m-d') == this.date) {
					left = (from.getHours() * 60) + from.getMinutes();
				}

				var right = day;
				var to = Date.normDate(item.booking.to);

				if (to.format('Y-m-d') == this.date) {
					right = (to.getHours() * 60) + to.getMinutes();
				}

				var width = right - left;

				return {
					left: ((left / day) * 100) + '%',
					width: ((width / day) * 100) + '%'
				};
			},
			dateRangeOverlaps(id, a_start, a_end, b_start, b_end) {
				/*if (id == 76) {
					
					
					
					
				}*/

				//return true;
				if ((a_start > b_start && a_start < b_end) || (a_end > b_start && a_end < b_end))	return true; // a in b
				if ((b_start > a_start && b_start < a_end) || (b_end > a_start && b_end < a_end))	return true; // b in a
				if (a_start.getTime() == b_start.getTime() 	&& a_end.getTime()	== b_end.getTime())	return true; // equal

				return false;
			},
			doesFit(track, booking) {
				//var stop = task.task.route[task.stopIdx];

				//

				//

				for (var i = 0; i < track.length; ++i) {
					var b = track[i].booking;

					// Overlap ?
					if (this.dateRangeOverlaps(b.res_id, Date.normDate(b.from), Date.normDate(b.to), Date.normDate(booking.from), Date.normDate(booking.to))) {
						//if (b.res_id == 76) 

						return false;
					}
				}

				//if (b.res_id == 76) 

				return true;
			},
			getTracks(res) {
				//
				var id = res.type + '_' + res.id;

				

				//
				//
				//
				//

				


			

				if (this._bookings.hasOwnProperty(id)) {
					var bookings = this._bookings[id];
					var tracks = [];



					//

					//

					for (var i = 0; i < bookings.length; ++i) {
						if (!this._tasks.hasOwnProperty(bookings[i].task_id)) {
							//
							continue;
						}

						var task = this._tasks[bookings[i].task_id];
						var foundTrack = false;
						var team = task.teams.find(function (team) {
							return team.id == bookings[i].team_id;
						});

						for (var j = 0; j < tracks.length; ++j) {
							if (this.doesFit(tracks[j], bookings[i])) {
								tracks[j].push({
									task: task,
									team: team,
									booking: bookings[i]
								});
								foundTrack = true;
								break;
							}
						}

						if (!foundTrack) {
							tracks.push([{
								task: task,
								team: team,
								booking: bookings[i]
							}]);
						}

						//
					}

					//

					return tracks;
				} else {
					return [];
				}

				/*if (this._tasks.hasOwnProperty(res.type + res.id)) {
					var tasks = this._tasks[res.type + res.id];
					var tracks = [];

					for (var i = 0; i < tasks.length; ++i) {
						var foundTrack = false;

						for (var j = 0; j < tracks.length; ++j) {
							if (this.doesFit(tracks[j], tasks[i])) {
								tracks[j].push(tasks[i]);
								foundTrack = true;
								break;
							}
						}

						if (!foundTrack) {
							tracks.push([tasks[i]]);
						}
					}

					return tracks;
				} else {
					return [];
				}*/
			},
			updateTime() {
				var d = new Date();

				this.time = {
					label: this.getFormattedDate(d, 'H:i'),
					seconds: (d.getHours() * 3600) + (d.getMinutes() * 60) + d.getSeconds()
				};
			},
			startTimer() {
				var v = this;

				this.stopTimer();
				this.updateTime();				

				this.timer = setInterval(function () {
					v.updateTime();
				}, 1000);
			},
			stopTimer() {
				if (this.timer !== null) {
					clearInterval(this.timer);
					this.timer = null;
					this.time = null;
				}
			},
			dragOver(e, res) {
				e.preventDefault();
				//this.hoverRes = res;
				this.$emit('hover', res);
			},
			dragLeave(e, res) {
				e.preventDefault();
				//this.hoverRes = res;
				this.$emit('hover', null);
			},
			drop(e, res) {
				

				if (this.drag.type == 'task') {
					if (this.drag.booking) {
						this.$emit('book', this.drag.booking.from, this.drag.booking.to, this.drag.task.id, this.drag.team.id, res.type, res.id, this.drag.booking);
					} else {
						this.$emit('book', this.drag.task.from.time, this.drag.task.to.time, this.drag.task.id, this.drag.team.id, res.type, res.id, this.drag.booking);
					}
				}

				if (this.drag.type == 'employee') {
					
					this.$emit('copyBookings', this.drag.emp, res.bookings);
				}
			}, 
			unbook(item, res) {
				

				this.$emit('unbook', item, res);

				/*res.id = null;
				this.$emit('book', {
					task: task,
					requirement: req,
					stopIdx: stopIdx,
					reqIdx: reqIdx,
					teamIdx: teamIdx
				}, res);*/
			},
			filterPopup(event) {
				var actions = [];
				var self = this;

				for (var i = 0; i < this.filters.length; ++i) {
					if (this.filters[i] === null) {
						actions.push(null);
						continue;
					}

					actions.push({
						label: this.filters[i].label,
						action: function () {
							var name = self.filters[i].value;

							return function () {
								self.$emit('filter', name);
							};
						}()
					});
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
			sortingPopup(event) {
				var actions = [];
				var self = this;

				for (var i in this.sorting.options) {
					actions.push({
						label: this.sorting.options[i],
						action: function () {
							var name = i;

							return function () {
								self.sorting.value = name;
							};
						}()
					});
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'right',
					actions: actions
				});
			},
			togglePinned() {
				this.pinned = !this.pinned;
			}
		},
		created() {
			if (this.types.length > 0) {
				this.type = this.types[0].name;
			}

			if (this.compareDates(Date.normDate(this.date), new Date()) == 0) {
				this.startTimer();
			}

			var self = this;

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.taskTypes = r.data._items;
				});
		},
		destroyed() {
			this.stopTimer();
		}
	}
</script>

<style lang="scss" scoped>
	.resource-view {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 60px 1fr;

		& > .header {
			border-bottom: 4px solid #f0f0f0;
			background-color: white;

			& > .list, & > .plan {
				height: 100%;
			}

			& > .list {
				border-right: 2px solid #cecece;
				position: relative;
				/*cursor: pointer;*/
				display: grid;
				grid-template-columns: 50px 1fr auto;
				grid-template-rows: 54px;

		

				& > .pin {
					& > .icon {
						width: 16px;
						height: 16px;
						margin: 19px 0 0 18px;
						fill: #CECECE;

						&.active {
							fill: black;
						}
					}					
				}

				& > .title {
					position: relative;
					font-size: 14px;
					font-weight: bold;
					line-height: 54px;
				}

		

				& > .title > .icon {
					width: 8px;
					height: 8px;
					margin-top: 5px;
					margin-left: 5px;
					margin-right: 19px;
				}

				& > .sorting {
					fill: rgb(145, 145, 145);
					color: rgb(145, 145, 145);
					font-weight: normal;
				}
			}

			& > .plan {
				position: relative;

				& > svg {
					width: 100%;
					height: 100%;

					& > line {
						stroke: #cecece;
						stroke-width: 1;
					}
				}

				& > .number {
					position: absolute;
					top: 0;
					height: 56px;
					line-height: 56px;
					text-align: center;
					width: 4.167%;
					font-size: 14px;
					font-weight: bold;
				}
			}
		}

		& > .header, & > .body > .content > .role > * {
			display: grid;
			grid-template-columns: 430px 1fr;
		}

		& > .header, & > .body > .content > .role > * {
			& > .list {
				position: relative;
			}
		}

		& > .body {
			position: relative;

			& > .bg {
				position: absolute;
				width: 100%;
				top: 0;
				bottom: 0;

		
				& > .list {
					border-right: 2px solid #cecece;
					background-color: white;
					left: 0;
					top: 0;
					height: 100%;
					width: 430px;

				
				}

				& > .plan {
					background-color: #F0F0F0;
					overflow: hidden;
					position: absolute;
					left: 430px;
					right: 0;
					top: 0;
					height: 100%;

					& > svg {
						width: 100%;
						height: 100%;

						& > line {
							stroke: #e1e1e1; 
							stroke-width: 1;

							&.odd {
								stroke-dasharray: 5px;
							}

							&.time {
								stroke: #F7223F;
							}
						}
					}
					
				}
			}

			& > .content {
				position: absolute;
				overflow-x: hidden;
				overflow-y: auto;
				width: 100%;
				height: 100%;

				& > .role {
					& > * > .list {
						height: 68px;
					}

					& > .title > .list {
						height: 45px;
						position: relative;

						& > .title {
							font-size: 16px;
							font-weight: bold;
							padding-left: 50px;
							padding-top: 10px;
							line-height: 35px;
						}

						& > .arrow {
							position: absolute;
							left: 15px;
							top: 10px;
							width: 35px;
							height: 35px;
							line-height: 35px;
							text-align: center;
						}
					}

					& > .item {
						margin-bottom: 10px;
						/*max-height: 500px;*/
						transition: height 0.25s, margin-bottom 0.25s, opacity 0.25s;

						&.title2 {
							margin-top: 50px;

							&:first-child {
								margin-top: 0;
							}
						}

						& > .list {
							& > .pos {
								display: grid;
								grid-template-columns: 16px;
								grid-template-rows: 1fr 1fr 1fr;
								height: 100%;
								margin-left: 20px;
								align-items: center;

								& > * {
							
									fill: #CECECE;
								}

								& > .up, & > .down {
									width: 8px;
									margin-left: 4px;
									opacity: 0;
								}

								& > .pin {
									opacity: 0.2;

									&.active {
										fill: #f7223f;
										opacity: 1;
									}
								}

								& > .down {
									
								}

								& > .gallery {
									position: relative;
									top: 7px;
									fill: #e0e0e0;

									&.active {
										fill: black;
									}
								}


							}

							& > .photo {
								width: 48px;
								height: 48px;
								border-radius: 50%;
								position: absolute;
								left: 50px;
								top: 10px;

							}

							& > .name {
								position: absolute;
								left: 115px;
								top: 14px;
								height: 20px;
								line-height: 20px;
								font-size: 14px;

								transition: left 0.25s, top 0.25s;

								&.title2 {
									font-weight: bold;
									white-space: nowrap;
									text-overflow: ellipsis;
									width: 200px ! important;
									overflow: hidden;
								}
							}

							

							& > .title {
								position: absolute;
								left: 115px;
								bottom: 14px;
								height: 20px;
								line-height: 20px;
								font-size: 12px;
								color: #a7a7a7;

						
							}

							& > .status {
								position: absolute;
								left: 84px;
								top: 8px;
								width: 8px;
								height: 8px;
								border: 1px solid white;

					
							}

							& > .time {
								position: absolute;
								top: 2px ! important;
								right: 30px;
								color: #a7a7a7;
								font-size: 12px;
								text-align: right;
								cursor: pointer;

								&.lvl1 {
									color: black;

									&.flag {
										color: #f7223f;
									}
								}

								&.lvl2 {
									color: rgb(0, 189, 0);
									font-weight: bold;
								}

								&.lvl3 {
									color: black;
									font-weight: bold;
								}

								&.back {
									right: 100px;
								}
							}
						}

				

						& > .list > .pos {
							& > .up.disabled, & > .down.disabled {
								opacity: 0;
								cursor: default;
								pointer-events: none;
							}
						}

						& > .plan {
							padding-top: 5px;
							position: relative;
							/*max-height: 500px;*/
							transition: height 0.25s, background-color 0.25s;

							& > .desc {
								position: absolute;
								left: 0;
								top: 0;
								color: white;
								padding: 3px 5px 3px 5px;
								opacity: 0.7;
								border-radius: 0 0 5px 0;
								
								> .note {
									font-size: 12px;
								}
							}

							& > div > .track {
								margin-bottom: 5px;
								height: 58px;
								position: relative;
								
								& > .task {
									box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

									display: grid;
									height: 58px;
									/*background-color: blue;*/
									border-radius: 5px;
									overflow: hidden;
									grid-template-columns: 5px 1fr;
									position: absolute;

									white-space: nowrap;
									text-overflow: ellipsis;

									background-color: #ffffff77 ! important;
					

									&.green {
										background-color: #00bd0077 ! important;
										color: white;
									}

									&.yellow {
										background-color: #facd0677 ! important;
										color: white;
									}

									&.red {
										background-color: #f72e277c ! important;
										color: white;
									}

									&.vehicle {
										background-color: rgb(0, 0, 0) ! important;
										color: white ! important;
									}

									& > .body {
										padding: 5px;

										& > .title {
											font-weight: bold;
											white-space: nowrap;
										}

										& > .zip {
											margin-top: 10px;
											white-space: nowrap;
										}
									}									
								}
							}
						}

						&.hover {
							background-color: #00c01623;
							/*background-color: #f5ed0333;
							background-color: #f7223e27;*/

							&.error {
								background-color: #f7223e27;
							}
						}
					}
				}
			}
		}
	}

	.resource-view.compact {
		& > .body {
			& > .content {
				& > .role {
					& > .item {
						& > .list {
							height: 20px;

							& > .name {
								left: 50px;
								top: 0;
								height: 20px;
								line-height: 20px;
							}

							& > .photo, & > .title {
								opacity: 0;
								pointer-events: none;
							}

							& > .time {
								top: 0;
							}
						}

						& > .plan {
							padding-top: 2px;

							& > .desc {
								display: none;
							}

							& > div > .track {
								height: 16px;
								margin-bottom: 2px;

								& > .task {
									height: 16px;
									
									display: block;

									font-size: 12px;
									line-height: 16px;
									padding-left: 3px;

									& > .color {
										width: 100%;
										height: 100%;
										color: white;
										font-size: 10px;
										line-height: 16px;
										padding-left: 5px;
									}

									& > .body {
										display: none;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.item-enter-active, .item-leave-active {
		transform: translateY(0);
		transition: opacity .25s, transform .25s, height .25s, margin-bottom .25s;
	}
	
	.item-enter, .item-leave-to /* .fade-leave-active below version 2.1.8 */ {
		
		opacity: 0;
		height: 0px;
		margin-bottom: 0px ! important;
	}

	.item-leave-to {
		transition-delay: 0ms ! important;
	}

	.track-enter-active, .track-leave-active {
		transform: translateY(0);
		transition: opacity 0.25s, transform 0.25s;
	}
	
	.track-enter, .track-leave-to /* .fade-leave-active below version 2.1.8 */ {
		
		opacity: 0;
	}

	.track-leave-to {
		transition-delay: 0ms ! important;
	}
</style>